import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  Filler, // Import Filler
} from "chart.js";
import { useSelector } from "react-redux";

// Register required Chart.js components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  Filler // Register Filler
);

const HumidityChart = ({ historicData }) => {
  const { theme } = useSelector((store) => store.dashboard)
  ChartJS.defaults.borderColor = theme === 'light' ? "#E2E8F0" : '#1E293B';
  ChartJS.defaults.color = theme === 'light' ? "#475569" : '#94A3B8';
  // Extract the dates and humidity data
  const dates = historicData.map((item) => {
    const dateObj = new Date(item.Date_time);
    const options = { month: "short", day: "numeric" };
    return dateObj.toLocaleDateString("en-US", options);
  });
  const rhData = historicData.map((data) => data.RH);
  const rhMaxData = historicData.map((data) => data.RH_max);
  const rhMinData = historicData.map((data) => data.RH_min);
  const days = dates.length;

  // Chart configuration
  const data = {
    labels: dates,
    datasets: [
      {
        label: "RH (%)",
        data: rhData,
        backgroundColor: "rgba(99, 102, 241, 0.25)",
        borderColor: "rgba(99, 102, 241, 1)",
        borderWidth: 2,
      },
      {
        label: "RH Max (%)",
        data: rhMaxData,
        backgroundColor: "rgba(14, 165, 233, 0.25)",
        borderColor: "rgba(14, 165, 233, 1)",
        borderWidth: 2,
      },
      {
        label: "RH Min (%)",
        data: rhMinData,
        backgroundColor: "rgba(245, 158, 11, 0.25)",
        borderColor: "rgba(245, 158, 11, 1)",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: theme === 'light' ? "#475569" : '#94A3B8',
        },
      },
      title: {
        display: true,
        text: `${days} Days Humidity Data`,
        color: theme === 'light' ? "#0F172A" : '#F8FAFC',
        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        title: {
          display: true,
          text: "Humidity (%)",
          color: theme === 'light' ? "#475569" : '#94A3B8',
        },
        ticks: {
          color: theme === 'light' ? "#64748B" : '#94A3B8',
        },
      },
      x: {
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        title: {
          display: true,
          text: "Date",
          color: theme === 'light' ? "#475569" : '#94A3B8',
        },
        ticks: {
          color: theme === 'light' ? "#64748B" : '#94A3B8',
        },
      },
    },
  };

  return (
    <div className="h-full w-full">
      <Line data={data} options={options} />
    </div>
  );
};

export default HumidityChart;
